// ** Routes Imports
import AppRoutes from './Apps'
import {isCMSAdmin, isStudentUser} from "../../utility/UserUtility";
import {getUserData} from "../../auth/utils";

// ** Document title
const TemplateTitle = 'Unisport akreditacijski sustav'

// ** Default Route
let DefaultRoute = '/natjecanja'
if (isCMSAdmin()) {
    DefaultRoute = '/objave'
}
if (getUserData() && getUserData().userData && getUserData().userData.role.includes("user") && getUserData().userData.role.length == 1) {
    DefaultRoute = "/rekreacije"
}

// ** Merge Routes
const Routes = [
    ...AppRoutes
]

export {DefaultRoute, TemplateTitle, Routes}
